import {
  UMEventsAccount,
  UMEventsAmplitude,
  UMEventsGeneric,
  UMEventsResponsibleGaming,
  UMEventsWallet
} from "./types";

export const getUMEvent = (
  event:
    | UMEventsAccount
    | UMEventsWallet
    | UMEventsAmplitude
    | UMEventsGeneric
    | UMEventsResponsibleGaming
) => ({
  trigger: event,
  completion: `${event}_COMPLETE`
});
